import type { ComponentProps } from 'react';

import {
	AttachmentAvatar,
	BasicAvatar,
	CardAvatar,
	CommentAvatar,
	DetailAvatar,
	HeroAvatar,
	ItemAvatar,
	MessageAvatar,
	MetaAvatar,
	ModalAvatar,
	RatingAvatar,
	SectionAvatar,
	TableAvatar,
	ThumbnailAvatar,
} from '@playbooks/molecules/avatars';

type AvatarLayout =
	| 'attachment'
	| 'basic'
	| 'card'
	| 'comment'
	| 'detail'
	| 'hero'
	| 'item'
	| 'message'
	| 'meta'
	| 'modal'
	| 'rating'
	| 'section'
	| 'table'
	| 'thumbnail';

type AvatarProps = {
	layout?: AvatarLayout;
	icon?: any;
	thumbnail?: any;
	photo?: any;
	title?: any;
	text?: any;
	badge?: any;
	badges?: any;
	href?: any;
	target?: any;
	length?: number;
	loading?: boolean;
	children?: any;
	className?: string;
};

export const Avatar = (props: AvatarProps) => {
	switch (props.layout) {
		case 'attachment':
			return <AttachmentAvatar {...(props as ComponentProps<typeof AttachmentAvatar>)} />;
		case 'basic':
			return <BasicAvatar {...(props as ComponentProps<typeof BasicAvatar>)} />;
		case 'card':
			return <CardAvatar {...(props as ComponentProps<typeof CardAvatar>)} />;
		case 'comment':
			return <CommentAvatar {...(props as ComponentProps<typeof CommentAvatar>)} />;
		case 'detail':
			return <DetailAvatar {...(props as ComponentProps<typeof DetailAvatar>)} />;
		case 'hero':
			return <HeroAvatar {...(props as ComponentProps<typeof HeroAvatar>)} />;
		case 'item':
			return <ItemAvatar {...(props as ComponentProps<typeof ItemAvatar>)} />;
		case 'message':
			return <MessageAvatar {...(props as ComponentProps<typeof MessageAvatar>)} />;
		case 'meta':
			return <MetaAvatar {...(props as ComponentProps<typeof MetaAvatar>)} />;
		case 'modal':
			return <ModalAvatar {...(props as ComponentProps<typeof ModalAvatar>)} />;
		case 'rating':
			return <RatingAvatar {...(props as ComponentProps<typeof RatingAvatar>)} />;
		case 'section':
			return <SectionAvatar {...(props as ComponentProps<typeof SectionAvatar>)} />;
		case 'table':
			return <TableAvatar {...(props as ComponentProps<typeof TableAvatar>)} />;
		case 'thumbnail':
			return <ThumbnailAvatar {...(props as ComponentProps<typeof ThumbnailAvatar>)} />;
		default:
			return <BasicAvatar {...(props as ComponentProps<typeof BasicAvatar>)} />;
	}
};

export type { AvatarLayout, AvatarProps };
